'use client';

import Image from 'next/image';
import React from 'react';

import Button from '@/components/Button';

import { useLanguage } from '@/contexts/LanguageContext';
import { redirectToWhatsApp } from '@/utils/whatsapp';

export default function DoctorIntro() {
  const { t, locale } = useLanguage();

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6">
      <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 sm:p-8 lg:p-16 flex flex-col justify-center order-2 lg:order-1">
            <div className="space-y-4 sm:space-y-6">
              <div>
                <span className="text-sm font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded-full">
                  {t.homepage.doctorIntro.title}
                </span>
              </div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#181C32]">
                {t.homepage.doctorIntro.name}
              </h2>
              <p className="text-base sm:text-lg text-[#181C32]/80 font-medium">
                {t.homepage.doctorIntro.description}
              </p>
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-start gap-3">
                  <div className="mt-1 flex-shrink-0">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-[#181C32]/80">
                    {t.homepage.doctorIntro.features.experience}
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="mt-1 flex-shrink-0">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-[#181C32]/80">
                    {t.homepage.doctorIntro.features.technology}
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="mt-1 flex-shrink-0">
                    <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <p className="text-sm sm:text-base text-[#181C32]/80">
                    {t.homepage.doctorIntro.features.approach}
                  </p>
                </div>
              </div>
              <div className="pt-4">
                <Button
                  variant="primary"
                  className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
                  onClick={() => redirectToWhatsApp(locale)}
                  aria-label={t.homepage.doctorIntro.button}
                >
                  {t.homepage.doctorIntro.button}
                </Button>
              </div>
            </div>
          </div>
          <div className="relative order-1 lg:order-2">
            <Image
              src="/images/doktor.webp"
              alt={t.homepage.doctorIntro.name}
              width={800}
              height={1000}
              className="object-cover w-full h-full"
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
} 